import classNames from 'classnames';

import ProductCardSkeleton from '@/components/common/Skeleton/new-product-card';
import { FC } from 'react';

const ProductsCarouselSkeleton: FC = () => {
  return (
    <div className="whitespace-nowrap overflow-hidden flex pt-0 ml-1.5 mt-200 my-2.5">
      {new Array(3).fill(0).map((_item, index) => {
        return (
          <ProductCardSkeleton
            key={`skeleton-product-list-item-${index}`}
            className={classNames('flex-shrink-0 !w-[150px] ml-1')}
          />
        );
      })}
    </div>
  );
};

export { ProductsCarouselSkeleton };

export default function Skeleton() {
  return (
    <div className="my-2.5 overflow-hidden">
      <div className="flex justify-between relative px-5">
        <div className="bg-surface-200-bg inline-block h-6 leading-8 w-24 rounded-sm skeleton" />
        <div className="bg-surface-200-bg inline-block h-6 leading-8 w-20 rounded-700 skeleton" />
      </div>
      <div className="whitespace-nowrap overflow-hidden flex pt-0 ml-1.5 mt-200">
        {new Array(3).fill(0).map((_item, index) => {
          return (
            <ProductCardSkeleton
              key={`skeleton-product-list-item-${index}`}
              className={classNames('flex-shrink-0 !w-[150px] ml-1')}
            />
          );
        })}
      </div>
    </div>
  );
}
